class CustomerLoginPage extends HTMLElement {
  constructor() {
    super();
    this.sectionForgottentPwd = null;
    this.sectionLogin = null;
  }

  onUrlChanged(evt) {
    const isRecover = window.location.hash === '#recover';
    this.sectionForgottentPwd.classList.toggle('hidden', !isRecover);
    this.sectionLogin.classList.toggle('hidden', isRecover);
  }

  init() {
    this.sectionForgottentPwd = this.querySelector('.section-recover-password');
    this.sectionLogin = this.querySelector('.section-login');
    window.addEventListener('popstate', this.onUrlChanged.bind(this));
    this.onUrlChanged();
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    });
  }
}


class CustomerCreateForm extends HTMLElement {
  constructor() {
    super();
    this.formEl = null;
  }

  onSubmitForm(evt) {
    evt.preventDefault();
    this.formEl.submit();
  }

  init() {
    this.formEl = this.querySelector('form');

    if (this.formEl) {
      this.formEl.addEventListener('submit', this.onSubmitForm.bind(this));
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    });
  }

  disconnectedCallback() {
    this.formEl.removeEventListener('submit', this.onSubmitForm.bind(this));
  }
}

class CustomerAddresses extends HTMLElement {
  constructor() {
    super();
    this.newAddressFormEl = null;
    this.buttonResetSelector = 'button[type="reset"]';
    this.buttonToggleSelector = 'button.toggle-button';
    this.buttonDeleteSelector = 'button.delete-button'
  }

  showHideForm(wrapperEl, state) {
    const formWrapper = this.querySelector(`#${wrapperEl}`);

    if (formWrapper) {
      if (state === undefined) {
        const isVisible = !formWrapper.classList.contains('hidden');
        console.log('formWrapper: isVisible : ', isVisible);
        formWrapper.classList.toggle('hidden', isVisible);
      } else {
        formWrapper.classList.toggle('hidden', !state);
      }
    }
  }

  deleteHandler({currentTarget}) {
    const confirmMessage = currentTarget.dataset.confirmMessage;
    if (confirmMessage && confirm(decodeURI(confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }

  addListeners() {
    const showHideFormButtons = this.querySelectorAll(this.buttonToggleSelector);
    const resetButtons = this.querySelectorAll(this.buttonResetSelector);
    const deleteButtons = this.querySelectorAll(this.buttonDeleteSelector);

    if (showHideFormButtons.length) {
      showHideFormButtons.forEach((buttonEl) => {
        buttonEl.addEventListener('click', this.showHideForm.bind(this, buttonEl.dataset.formWrapperId, undefined));
      });
    }
    if (resetButtons.length) {
      resetButtons.forEach((buttonEl) => {
        buttonEl.addEventListener('click', this.showHideForm.bind(this, buttonEl.dataset.formWrapperId, false));
      });
    }
    if (deleteButtons.length) {
      deleteButtons.forEach((buttonEl) => {
        buttonEl.addEventListener('click', this.deleteHandler.bind(this));
      });
    }
  }

  initCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('address-country-new', 'address-province-new', {
        hideElement: 'address-province-container-new',
      });
      const countrySelects = this.querySelectorAll('select[data-form-id]');
      countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`address-country-${formId}`, `address-province-${formId}`, {
          hideElement: `address-province-container-${formId}`,
        });
      });
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.addListeners();
      this.initCountries();
    });
  }

  disconnectedCallback() {
  }
}

customElements.define('customer-login-page', CustomerLoginPage);
customElements.define('customer-create-form', CustomerCreateForm);
customElements.define('customer-addresses', CustomerAddresses);
